import React from 'react'
import { Modal, Form, Input } from 'antd'

interface PasswordResetModalProps {
  visible: boolean
  onCancel: () => void
  onSubmit: (password: string) => Promise<void>
  username?: string
  loading?: boolean
}

const PasswordResetModal: React.FC<PasswordResetModalProps> = ({
  visible,
  onCancel,
  onSubmit,
  username,
  loading = false
}) => {
  const [form] = Form.useForm()

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields()
      await onSubmit(values.password)
      form.resetFields()
    } catch (error) {
      console.error('Password reset error:', error)
    }
  }

  const handleCancel = () => {
    form.resetFields()
    onCancel()
  }

  return (
    <Modal
      title="重置密码"
      open={visible}
      onCancel={handleCancel}
      onOk={handleSubmit}
      confirmLoading={loading}
    >
      <div style={{ marginBottom: 16 }}>
        <strong>用户：</strong>{username}
      </div>
      
      <Form
        form={form}
        layout="vertical"
        preserve={false}
      >
        <Form.Item
          name="password"
          label="新密码"
          rules={[
            { required: true, message: '请输入新密码' },
            { min: 6, message: '密码至少6个字符' },
            { max: 100, message: '密码最多100个字符' }
          ]}
        >
          <Input.Password placeholder="请输入新密码" />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label="确认密码"
          dependencies={['password']}
          rules={[
            { required: true, message: '请确认密码' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve()
                }
                return Promise.reject(new Error('两次输入的密码不一致'))
              },
            }),
          ]}
        >
          <Input.Password placeholder="请再次输入密码" />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default PasswordResetModal